import { Pipe, PipeTransform } from '@angular/core';
import { AppData } from 'fakturnia-shared';

/**
 * Pipe do inteligentnego wyświetlania adresu klienta
 * Pomija puste wartości i niepotrzebne przecinki
 * 
 * @example
 * ```html
 * <!-- Pełny adres z krajem -->
 * {{ client | clientAddress }}
 * 
 * <!-- Adres bez kraju -->
 * {{ client | clientAddress:false }}
 * ```
 */
@Pipe({
  name: 'clientAddress',
  standalone: true
})
export class ClientAddressPipe implements PipeTransform {
  
  transform(client: any, includeCountry: boolean = true): string {
    if (!client) return '';

    const parts: string[] = [];

    // Dodaj ulicę jeśli istnieje
    if (client.street?.trim()) {
      parts.push(client.street.trim());
    }

    // Dodaj kod pocztowy i miasto
    const cityPart: string[] = [];
    if (client.postalCode?.trim()) {
      cityPart.push(client.postalCode.trim());
    }
    if (client.city?.trim()) {
      cityPart.push(client.city.trim());
    }
    
    if (cityPart.length > 0) {
      parts.push(cityPart.join(' '));
    }

    // Dodaj kraj jeśli requested
    if (includeCountry) {
      const countryCode = client.countryCode || AppData.getCountryCodeByName(client.country);
      const countryName = countryCode 
        ? AppData.getCountryNameByCode(countryCode) 
        : client.country;
      
      if (countryName?.trim()) {
        parts.push(countryName.trim());
      } else {
        parts.push('Polska'); // Fallback
      }
    }

    // Połącz wszystko przecinkami
    return parts.join(', ') || 'Brak adresu';
  }
}

